<app-content>
  <br>
  <app-spinner *ngIf='!error'>
    Poczekaj trwa ładowanie danych...
    <br>
    <small style='font-weight: normal'>
      Za chwile nastąpi przekierowanie do <strong>login.gov.pl</strong>
    </small>
  </app-spinner>
  <app-alert
    *ngIf='error as v'
    [closable]='false'
    type='danger'
    [alertTitle]='v.status + " " + v.statusText'>
    {{ error.message }}
  </app-alert>
  <form *ngIf='data() as formData'
        #formElement
        id='login.gov.pl-form'
        hidden
        [action]='formData.action'
        method='post'>
    <input id='SAMLRequest' name='SAMLRequest' type='text' [value]='formData.data.SAMLRequest'>
    <span *ngIf='formElement.submit()'></span>
  </form>
</app-content>
